import { createAction, Dispatch } from '@reduxjs/toolkit';

export const toggleMenuOpen = createAction<boolean>('toggleMenuOpen');

export const setMenuOpen = (isOpen: boolean) => (dispatch: Dispatch) => {
    return dispatch(toggleMenuOpen(isOpen));
};
